'use client';

import { Flex, Text } from '@chakra-ui/react';
import SectionContainer from '@/components/shared/SectionContainer';
import QueryBoundary from '@/components/ui/QueryBoundary';
import ProductFinderContent from './components/ProductFinderContent';
import ProductFinderSkeleton from './components/ProductFinderSkeleton';

const ProductFinderSection = () => {
  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'brand.50',
        paddingY: 16,
      }}
    >
      <Flex alignItems="flex-start" direction="column" gap={{ base: 12, tablet: 16 }} width="100%">
        <Text color="common.100" textStyle="heading2" fontWeight="regular" alignSelf="flex-start" width="100%">
          Find Your Perfect Product
        </Text>

        <QueryBoundary loadingFallback={<ProductFinderSkeleton />}>
          <ProductFinderContent />
        </QueryBoundary>
      </Flex>
    </SectionContainer>
  );
};

export default ProductFinderSection;
